<template>
  <v-card id="tract-visit-move">
    <v-card-title class="primary">
      <span class="headline white--text">{{ $t('moveVisit') }}</span>
      <v-spacer/>
      <BaseDialogActions hideRefresh hideFullscreen/>
    </v-card-title>
    <v-card-text>
      <FormWrapper
      formRef="tractVisitMoveForm"
      buttonId="tract-visit-move-submit"
      :buttonText="$t('move')"
      :disabled="!targetTract"
      @submit="$emit('move', targetTract)">
        <v-container fluid class="pt-4">
          <v-row dense>
            <v-col cols="12">
              <p class="subtitle-1 black--text font-weight-medium">{{ $t('moveVisitBody', { type: visit.tractVisitTypeName, tract: tract.name }) }}</p>
              <BidTractAutocomplete
              :tractFilter="eligibleTargetTract"
              :originSpot="tract.spot"
              @tract-chosen="targetTract = $event"/>
            </v-col>
          </v-row>
        </v-container>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import { TractStatus } from '@/utils/Enumerations.js'

export default {
  name: 'TractVisitMoveDialog',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue'),
    BidTractAutocomplete: () => import('@/components/bid/BidTractAutocomplete.vue')
  },

  props: {
    tract: {
      type: Object,
      required: true
    },
    visit: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    targetTract: undefined
  }),

  methods: {
    eligibleTargetTract (candidate) {
      return candidate.tractId !== this.tract.tractId &&
        candidate.status !== TractStatus.Closed.value &&
        candidate.status !== TractStatus.Archived.value
    }
  }
}
</script>
